import React, {useMemo} from 'react';
import {Link} from "react-router-dom";
import {SVG} from '@broadleaf/admin-components/dist/common/components/SVG/SVG';
import Popover from "@broadleaf/admin-components/dist/common/components/Popover/Popover";
import useTenantContext from "@broadleaf/admin-components/dist/tracking/hooks/useTenantContext";

export const HelpButton: React.FC = () => {
    const parentRef = React.useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [{applicationId}] = useTenantContext();
    const url = useMemo(() => {
        if (applicationId === null) {
            return '/dealer-tenant-help-documents';
        }
        return '/dealer-help-documents';
    }, [applicationId]);
    return (
        <Link to={url}
              onMouseEnter={() => setIsOpen(true)}
              onMouseLeave={() => setIsOpen(false)}
        >
            <div ref={parentRef} className="tw-h-9 HelpButton">

                <div
                    className={'tw-h-full focus:tw-shadow-outline motion-reduce:transition-none tw-inline-flex tw-items-center ' +
                        'tw-space-x-2 tw-whitespace-nowrap tw-py-2 tw-transition focus:tw-outline-none rtl:tw-space-x-reverse ' +
                        'tw-text-sm tw-rounded tw-px-4 tw-shadow hover:tw-shadow-md DropdownTrigger tw-relative tw-inline-flex ' +
                        'tw-justify-between tw-group tw-h-full tw-w-full tw-truncate tw-bg-gray-700 tw-text-gray-300 tw-transition-colors hover:tw-bg-gray-600 hover:tw-text-gray-100'}>
                    <SVG name={'education'} className={'tw-h-4 tw-w-4 tw-fill-current'}/>
                </div>
            </div>
            <Popover
                parent={parentRef}
                active={isOpen}
                position="bottom"
                color="gray-900"
                className="tw-rounded tw-px-4 tw-py-2 tw-text-sm tw-text-gray-300"
            >Help</Popover>
        </Link>
    );
}

export default HelpButton;